import Alpine from 'alpinejs'

Alpine.data('projectList', () => ({
    open: localStorage.getItem('showProjectMap') !== '0',
    mobileOpen: false,

    toggleMap() {
        this.open = !this.open;
        localStorage.setItem("showProjectMap", this.open ? "1" : "0");
    }
}));
